import React, { useEffect, useMemo, useState } from 'react';
import { Markdown as MD } from '@features/markdown/components/Markdown';
import { BsGear } from 'react-icons/bs';
import ErrorBoundary from '@components/tailwind/ErrorBoundary';
import SectionScroll from '@features/pdp/components/SectionScroll';
import AnimatedSlider from '@features/pdp/components/AnimatedSlider';

const idMap = {
  features: 'TechAndFeatures',
  whyWeLoveIt: 'WhyWeLoveIt',
};

const Slides = ({ children = [], ...props }) => {
  return (
    <ErrorBoundary>
      <AnimatedSlider
        id={
          idMap[props?.attributes?.role] ||
          props?.attributes?.role ||
          Math.random().toString(36).substring(2, 15)
        }
        sliderTitle={props?.attributes?.title}
        sliderBottomNote={props?.attributes?.bottomNote}
        slides={children.map((c) => c.attributes)}
      />
    </ErrorBoundary>
  );
};

export default Slides;
